import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" richColors />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Check for updates periodically (with error handling)
        setInterval(() => {
          registration.update().catch((err) => {
            // Silently handle update errors to avoid console spam
            console.debug('SW update check failed:', err.message);
          });
        }, 60000);

        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available, reload to get updates
                if (newWorker.postMessage) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                }
                window.location.reload();
              }
            });
          }
        });
      })
      .catch((err) => {
        console.log('SW registration failed: ', err);
      });
  });

  // Handle controller change (new service worker activated)
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}
